import { HttpClient, URL_API } from "../../network";

export type TTransaction = {
  _id: string;
  User: User[];
  amount: number;
  transaction_id: string;
  type: string;
  payment_type: string;
  is_paid: boolean;
  status: string;
  ChargeSession: ChargeSession;
  gst: number;
  createdAt: string;
  CPO: User[];
  SeedingPartner: User[];
  user_name: string;
  chargepoint_name: string;
  evse_name: string;
  charge_session_id: string;
  charging_fee_with_gst: number;
  idling_fee_with_gst: number;
  description?: string;
  is_refunded?: boolean;
  refunded_at?: string | null;
  refunded_amount?: number;
  payment_info?: CardInfo | string;
};

interface CardInfo {
  exp_month: number;
  exp_year: number;
  last4: string;
}
interface ChargeSession {
  _id: string;
  session_started_at: string;
  session_ended_at: string;
}
interface User {
  _id: string;
  name: string;
  phone: string;
  email: string;
}

class Transaction extends HttpClient {
  getAll = async (params: TParams) => {
    const data = await this.instance.get<IResponse<Array<TTransaction>>>(
      URL_API.TRANSACTIONS.GET_LIST,
      {
        params,
      }
    );
    return data;
  };
}
export const TransactionService = new Transaction();
